import { initWhyCarousel } from "../component/why-carousel.js";
import { initOfficeHoverReveal } from "../component/office-hover-reveal.js";
import { initAccordionGroups } from "../component/accordion.js";
import { initContextMenu } from "../component/disable-rightclick.js";
import { initGlowWrapper } from "../component/glow.js";

import {
  initCookieBar,
  initDmcabadge,
  initGooglePreferredSource,
} from "../component/bottom-cookie-bar.js";
import initMobileMenu from "../component/mobile-menu.js";

initDmcabadge();
initCookieBar();
initGooglePreferredSource();
initWhyCarousel();
initOfficeHoverReveal();
initAccordionGroups();
initMobileMenu();
initContextMenu();

document.addEventListener("DOMContentLoaded", () => {
  initGlowWrapper();
});
